<template>
  <object v-if="!isApp && pdfUrl" :key="pdfUrl" width="100%" height="400px" :data="pdfUrl" class="rounded border-white"></object>
  <v-btn v-else color="primary" block @click="$emit('open')">PDF Öffnen</v-btn>
</template>

<script>
import api from "@/api"

export default {
  props: {
    userId: { type: String, required: true },
    contractIndex: { type: [Number, String], required: true },
    isApp: { type: Boolean, default: false },
  },
  data() {
    return { pdfUrl: null, previewClosed: false }
  },
  mounted() {
    if (!this.isApp) this.loadPreview()
  },
  beforeDestroy() {
    this.previewClosed = true
    if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl)
  },
  methods: {
    async loadPreview() {
      try {
        const blob = await api.getIframeprintUserContract(this.userId, this.contractIndex, "Vorschau")
        // A keyed replacement may destroy this preview while its request is still pending.
        if (this.previewClosed) return
        this.pdfUrl = URL.createObjectURL(blob)
      } catch (error) {
        if (!this.previewClosed) this.$toast.error("Vorschau konnte nicht geladen werden")
      }
    },
  },
}
</script>
